import React from 'react';
import { Link, useParams} from "react-router-dom";
function FeaturedSection() {
  const { section, id } = useParams();
  return (
    <section id="featured-services" className="featured-services section light-background">
      <div className="container section-title" data-aos="fade-up">
        {/* <h2>PUBLIC ANNOUNCEMENT</h2> */}
        <p>
          <span>Our Commitment</span>
          <span className="description-title"> To Excellence</span>
        </p>
      </div>
      <div className="container">
        <div className="row gy-4">

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay={100}>
            <div className="service-item position-relative">
              <div className="icon"><i className="fa fa-home" /></div>
              <h4><Link to="#" className="stretched-link">Affordable and Inclusive Housing</Link></h4>
              <p>We are dedicated to providing accessible, safe, and affordable housing solutions that improve the living standards of Nigerians across all communities.</p>
            </div>
          </div>

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay={200}>
            <div className="service-item position-relative">
              <div className="icon"><i className="fa fa-building" /></div>
              <h4><Link to="#" className="stretched-link">Sustainable Urban Development</Link></h4>
              <p>Through strategic planning and responsible policies, we promote well-organized cities, resilient infrastructure, and environmentally sustainable urban growth.</p>
            </div>
          </div>

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay={300}>
            <div className="service-item position-relative">
              <div className="icon"><i className="fa fa-road" /></div>
              <h4><Link to="#" className="stretched-link">Efficient Infrastructure Delivery</Link></h4>
              <p>We drive the development and renewal of public infrastructure, ensuring modern facilities and improved urban services for long-term national progress.</p>
            </div>
          </div>

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay={400}>
            <div className="service-item position-relative">
              <div className="icon"><i className="fa fa-shield" /></div>
              <h4><Link to="#" className="stretched-link">Transparency and Public Trust</Link></h4>
              <p>We uphold accountability, professionalism, and integrity in every project and policy, ensuring effective service delivery and public confidence in our mission.</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default FeaturedSection;